import React, { Fragment, useEffect } from "react";
import Router from "./routers/router";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { resetAllMessage } from "./redux";
import { getCoachProfile } from "./services/coachService";

const App = () => {
  const { hasError, hasNotification, hasSuccess, hasWarning, message } =
    useSelector((state) => state.notification);
  const { coach, isLoggedIn } = useSelector((state) => state.coach);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn && !coach) {
      getCoachProfile();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const showToast = (type, msg) => {
      if (!toast.isActive(msg)) {
        toast[type](msg, {
          toastId: msg, // Assign a unique ID to prevent duplication
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    };

    if (message.length > 0) {
      if (hasNotification) showToast("info", message);
      if (hasWarning) showToast("warn", message);
      if (hasError) showToast("error", message);
      if (hasSuccess) showToast("success", message);

      dispatch(resetAllMessage());
    }
  }, [hasError, hasNotification, hasSuccess, hasWarning, message, dispatch]);

  return (
    <Fragment>
      <ToastContainer />
      <Router />
    </Fragment>
  );
};

export default App;
